import workspaceQuery from 'graphql/queries/purchases/PurchaseOrderAuditByFieldWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/common/AuditByFieldFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const PurchaseOrderAuditByField = {
  type: 'AuditChange',
  workspace: workspaceQuery,
  fragment,
  operations: ALLOW_VIEW,
};

export default PurchaseOrderAuditByField;
